export default {"src":"/_next/static/media/freeyou.3b3669e7.svg","height":40,"width":177,"blurWidth":0,"blurHeight":0};